import React, { useState } from 'react';
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { IoCloseCircleOutline } from "react-icons/io5";
import Lottie from 'react-lottie-player';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import ChatroomBell from './chatroom/ChatroomBell';

import bubbleAnimation from '../Assets/Animation - 1723542970347.json';

const PublicHeader = () => {
    const { user, logOut, isAdmin } = UserAuth();
    const [selected, setSelected] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const handleSelect = (item) => {
        setSelected(item);
        setMenuOpen(false); 
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = async () => {
        try {
            await logOut();
            navigate('/'); 
        } catch (error) {
            console.log(error);
        }
    };

    const menuItems = [
        { name: 'Backtesting', path: '/backtesting' },
        { name: 'Automation', path: '/automation' },
        { name: 'Trade Alerts', path: '/signals' },
        { name: 'Charts', path: '/macro' },
        { name: 'Blog', path: '/blog' },
    ];

    return (
        // Outer wrapper (full width)
        <div className="fixed top-0 left-0 w-full z-50 bg-[#12181B]">
          {/* Inner container (centered content, constrained width) */}
          <div className="flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white">
            
            {/* Logo and Title */}
            <div className="flex items-center">
              <Link to="/" onClick={() => handleSelect(null)}>
                <Lottie
                  loop
                  animationData={bubbleAnimation}
                  play
                  style={{ width: 100, height: 40 }}
                />
              </Link>
              <Link to="/" onClick={() => handleSelect(null)}>
                <h1 className="text-sm font-bold flex items-center">
                  <span className="text-[#00df9a] font-bold">BUBBLE</span>ANALYTICS
                </h1>
              </Link>
            </div>
    
            {/* Desktop Menu */}
            <div className="hidden md:flex flex-1 justify-center items-center">
              <ul className="flex space-x-2 text-sm font-hyperlegible list-none items-center">
                {menuItems.map((item) => (
                  <li
                    key={item.name}
                    className={`p-4 cursor-pointer ${
                      selected === item.name ? 'text-[#00df9a]' : 'text-white'
                    } hover:text-[#00df9a]`}
                    onClick={() => handleSelect(item.name)}
                  >
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
    
            {/* Authentication Links (Desktop) */}
            {user && <div className="mr-3"><ChatroomBell /></div>}
            <div className="hidden md:flex items-center space-x-4">
              {user ? (
                <>
                  {isAdmin && (
                    <Link to="/dashboard">
                      <li
                        className={`p-0 font-hyperlegible text-sm cursor-pointer list-none ${
                          selected === 'Dashboard' ? 'text-[#00df9a]' : 'text-white'
                        } hover:text-[#00df9a]`}
                        onClick={() => handleSelect('Dashboard')}
                      >
                        Dashboard
                      </li>
                    </Link>
                  )}
                  <Link to="/account">
                    <li
                      className={`p-0 font-hyperlegible text-sm cursor-pointer list-none ${
                        selected === 'Account' ? 'text-[#00df9a]' : 'text-white'
                      } hover:text-[#00df9a]`}
                      onClick={() => handleSelect('Account')}
                    >
                      Account
                    </li>
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="cursor-pointer bg-transparent border border-[#00df9a] text-[#00df9a] font-hyperlegible text-sm py-0 px-6 rounded transition duration-300 hover:border-transparent hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 focus:border-transparent focus:bg-gray-700 focus:text-transparent focus:bg-clip-text focus:bg-gradient-to-r focus:from-pink-500 focus:to-blue-500 active:animate-pulse"
                  >
                    Log Out
                  </button>
                </>
              ) : (
                <>
                  <Link to="/signin">
                    <li
                      className={`p-0 text-sm mt-1 font-hyperlegible cursor-pointer list-none ${
                        selected === 'Sign In' ? 'text-[#00df9a]' : 'text-white'
                      } hover:text-[#00df9a]`}
                      onClick={() => handleSelect('Sign In')}
                    >
                      Account
                    </li>
                  </Link>
                  <Link to="/signin">
                    <button className="cursor-pointer bg-transparent border border-[#00df9a] text-[#00df9a] font-hyperlegible text-sm py-0 px-6 rounded transition duration-300 hover:border-transparent hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 focus:border-transparent focus:bg-gray-700 focus:text-transparent focus:bg-clip-text focus:bg-gradient-to-r focus:from-pink-500 focus:to-blue-500 active:animate-pulse">
                      Log In
                    </button>
                  </Link>
                </>
              )}
            </div>
    
            {/* Mobile Menu Icon */}
            <div className="mr-6 md:hidden flex items-center" onClick={toggleMenu}>
              {!menuOpen ? <HiOutlineMenuAlt3 size={20} /> : <IoCloseCircleOutline size={20} />}
            </div>
          </div>
    
          {/* Dropdown Menu (Mobile) */}
          <div
            className={`fixed top-24 left-0 h-full w-[60%] bg-[#12181B] text-left text-white ease-in-out duration-500 transform ${
              menuOpen ? 'translate-x-0' : '-translate-x-full'
            }`}
          >
            <ul className="flex flex-col space-y-1 text-sm font-hyperlegible pl-10 list-none">
              {menuItems.map((item) => (
                <li
                  key={item.name}
                  className={`p-4 cursor-pointer uppercase ${
                    selected === item.name ? 'text-[#00df9a]' : 'text-white'
                  } hover:text-[#00df9a]`}
                  onClick={() => handleSelect(item.name)}
                >
                  <Link to={item.path}>{item.name}</Link>
                </li>
              ))}
              {user ? (
                <>
                  {isAdmin && (
                    <li
                      className={`p-4 cursor-pointer uppercase list-none ${
                        selected === 'Dashboard' ? 'text-[#00df9a]' : 'text-white'
                      } hover:text-[#00df9a]`}
                      onClick={() => handleSelect('Dashboard')}
                    >
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                  )}
                  <li
                    className={`p-4 cursor-pointer uppercase list-none ${
                      selected === 'Account' ? 'text-[#00df9a]' : 'text-white'
                    } hover:text-[#00df9a]`}
                    onClick={() => handleSelect('Account')}
                  >
                    <Link to="/account">Account</Link>
                  </li>
                  <li
                    className={`p-4 cursor-pointer uppercase list-none ${
                      selected === 'Sign Out' ? 'text-[#00df9a]' : 'text-white'
                    } hover:text-[#00df9a]`}
                    onClick={handleLogout}
                  >
                    Log Out
                  </li>
                </>
              ) : (
                <>
                  <li
                    className={`p-4 cursor-pointer uppercase list-none ${
                      selected === 'Sign In' ? 'text-[#00df9a]' : 'text-white'
                    } hover:text-[#00df9a]`}
                    onClick={() => handleSelect('Sign In')}
                  >
                    <Link to="/signin">Account</Link>
                  </li>
                  <li
                    className={`p-4 cursor-pointer uppercase list-none ${
                      selected === 'Log In' ? 'text-[#00df9a]' : 'text-white'
                    } hover:text-[#00df9a]`}
                    onClick={() => handleSelect('Log In')}
                  >
                    <Link to="/signin">Log In</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
    );
}

export default PublicHeader;
